import { z } from "zod";

const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{10,30}$/;

export default {
  login: z.object({
    email: z.string().email({ message: "Invalid email address" }),
    password: z
      .string()
      .min(6, { message: "Password must be at least 6 characters long" }),
  }),
  forgotPassword: z.object({
    email: z.string().email({ message: "Invalid email address" }),
  }),
  resetPassword: z
    .object({
      newPassword: z
        .string()
        .min(6, { message: "Password must be at least 6 characters long" }),
      repeatPassword: z
        .string()
        .min(6, { message: "Password must be at least 6 characters long" }),
    })
    .refine((data) => data.newPassword === data.repeatPassword, {
      message: "Passwords must match",
      path: ["repeatPassword"],
    }),
  vendor: z
    .object({
      external_id: z.string().optional().nullable(),
      title: z.string().max(50, { message: "Title max size is 50 characters" }),
      company_id: z
        .string()
        .max(18, { message: "Company ID max size is 18 characters" }),
      email: z.string().email({ message: "Invalid email address" }),
      phone: z.string().max(18, { message: "Phone max size is 18 characters" }),
      iban: z
        .string()
        .trim()
        .toUpperCase()
        .min(15, { message: "IBAN must be at least 15 characters long" }) 
        .max(34, { message: "IBAN must not exceed 34 characters" })
        .regex(ibanRegex, {
          message: "Invalid IBAN format",
        }),
      vat_registered: z.boolean({
        required_error: "VAT registration status is required",
      }),
      address: z
        .object({
          country: z.enum(
            [
              "AT",
              "BE",
              "BG",
              "BY",
              "HR",
              "CY",
              "CZ",
              "DK",
              "EE",
              "FI",
              "FR",
              "GE",
              "DE",
              "GR",
              "HU",
              "IS",
              "IE",
              "IT",
              "LV",
              "LI",
              "LT",
              "LU",
              "MT",
              "NL",
              "NO",
              "PL",
              "PT",
              "RO",
              "RU",
              "SK",
              "SI",
              "ES",
              "SE",
              "CH",
              "GB",
            ],
            { message: "Invalid country" }
          ),
          city: z
            .string()
            .max(24, { message: "City max size is 24 characters" }),
          street: z
            .string()
            .max(36, { message: "Street max size is 36 characters" }),
          zipCode: z
            .string()
            .max(18, { message: "Postal code max size is 18 characters" })
            .optional(),
        })
        .strict(),
    })
    .strict(),
  vendor_user: z.object({
    external_id: z.string().optional().nullable(),
    vendor_id: z.string().optional().nullable(),
    vendor: z.string().optional().nullable(),
    first_name: z
      .string()
      .min(2, "First name min size is 2 characters")
      .max(36, "First name max size is 36 characters"),
    last_name: z
      .string()
      .min(2, "Last name min size is 2 characters")
      .max(36, "Last name max size is 36 characters"),
    role: z.enum(["ADMIN", "ACCOUNTANT"]),
    email: z.string().email("Invalid email address"),
    password: z.string().min(8, "Password must be at least 8 characters"),
  }),
  changePassword: z
    .object({
      currentPassword: z
        .string()
        .min(6, { message: "Password must be at least 6 characters long" }),
      newPassword: z
        .string()
        .min(6, { message: "Password must be at least 6 characters long" }),
      repeatPassword: z
        .string()
        .min(6, { message: "Password must be at least 6 characters long" }),
    })
    .refine((data) => data.newPassword !== data.currentPassword, {
      message: "New password must be different from current password",
      path: ["newPassword"],
    })
    .refine((data) => data.newPassword === data.repeatPassword, {
      message: "Passwords must match",
      path: ["repeatPassword"],
    }),
  brand: z
    .object({
      external_id: z.string().optional().nullable(),
      title: z.string().max(50, { message: "Title max size is 50 characters" }),
      handle: z.string().regex(/^(?!.*\/\/)[a-z][a-z0-9-]{5,49}(?<!-)$/, {
        message:
          "Handle can only contain lowercase letters, numbers and hyphen. Must start with letter. Can't end with hyphen",
      }),
      logo_url: z
        .string()
        .url({ message: "Invalid URL" })
        .optional()
        .nullable(),
    })
    .strict(),
};
